import React, { useEffect } from 'react'
import { Layout, Spin } from 'antd'
import { connect } from 'react-redux'
import { segmentApi } from '@edulastic/api'
import { TRACK_IDS } from '@edulastic/constants/educationJoyrides'
import HeaderSection from './Header/Header'
import MainContent from './Showcase/showcase'
import NewHeaderSection from './Header/NewHeader'
import {
  getDashboardSettingsSelector,
  getUserContextsLoading,
  getIsIlpDashboardJoyridePending,
} from '../ducks'
import NewDashboard from './Showcase/components/NewDashboard'
import EducationJoyride from '../../src/components/EducationJoyride'
import ProfileReportsJoyride from './ProfileReportsJoyride'
import { DASHBOARD_VISIT_SEGMENT_EVENT } from '../constants'
import {
  allowInstantLessonPackageSelector,
  getUserFeatures,
} from '../../src/selectors/user'

const Dashboard = ({
  userId,
  history,
  dashboardSettings: { dashboardVersion },
  isUserContextLoading,
  allowInstantLessonPackage,
  isILPButtonBlacklisted,
  isIlpDashboardJoyridePending,
}) => {
  // For gcps district it is not important for the user context to load
  // as always old dashboard has to be loaded.
  const waitForUserContext = isUserContextLoading

  useEffect(() => {
    if (!userId || waitForUserContext) return
    segmentApi.genericEventTrack(DASHBOARD_VISIT_SEGMENT_EVENT, {
      dashboardVersion: dashboardVersion ? 'new' : 'old',
    })
  }, [userId, waitForUserContext])

  if (!userId || waitForUserContext) {
    return <Spin />
  }
  return (
    <Layout>
      {dashboardVersion ? (
        <>
          <NewHeaderSection history={history} />
          <NewDashboard />
        </>
      ) : (
        <>
          <HeaderSection history={history} />
          <MainContent />
        </>
      )}
      {/* ILP joyride is the highest-priority dashboard joyride — it defers to
          nothing. Class Reports and Curriculum wait for it. */}
      {dashboardVersion ? (
        <EducationJoyride
          trackId={TRACK_IDS.GENAI_DASHBOARD_ILP}
          featureGate={allowInstantLessonPackage && !isILPButtonBlacklisted}
          contextsLoading={isUserContextLoading}
        />
      ) : null}
      {/* Class Reports is next in line — hold it back while the ILP joyride is
          still pending so the two never overlap. */}
      {!isIlpDashboardJoyridePending ? <ProfileReportsJoyride /> : null}
    </Layout>
  )
}
export default connect((state) => ({
  userId: state?.user?.user?._id,
  dashboardSettings: getDashboardSettingsSelector(state),
  isUserContextLoading: getUserContextsLoading(state),
  allowInstantLessonPackage: allowInstantLessonPackageSelector(state),
  isILPButtonBlacklisted: getUserFeatures(state)?.isILPButtonBlacklisted,
  isIlpDashboardJoyridePending: getIsIlpDashboardJoyridePending(state),
}))(Dashboard)
